module.exports = __webpack_public_path__ + "img/logoBig_thumb.bbb845f3.jpg";